<template>
    <div class="chart">
        <apexchart type="bar" ref="chart" height="380" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  export default {
    name: 'chartFasyankesPerKota',
    components: {
      apexchart: VueApexCharts,
    },
    props: {
      models: {
        type: Object,
        required: true,
      },
    },
    mounted() {
      this.getData();
    },
    data: function () {
      return {
        series: [
          {
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 380,
            events: {
              mounted: (chart) => {
                chart.windowResizeHandler();
              }
            }
          },
          xaxis: {
            categories: [],
          },
          title: {
            text: 'Jenis Fasyankes per Kota/Kab, tahun ' + this.models.year,
          },
          plotOptions: {
            bar: {
              dataLabels: {
                position: 'top',
              },
            },
          },
          legend: {
            show: false
          }
        }
      }
    },
    methods: {
      getData() {
        const _ = this;
        _.$axios.get('FasyankesDashboard/JenisFasyankesPerKota', {
          params: {
              years: _.models.year,
            }
          })
          .then(res => {
            let data = res.data.data;
            _.chartOptions.xaxis.categories = [];

            _.series = [
              {
                name: "Rumah Sakit",
                data: data.map(v => v.countRS)
              },
              {
                name: "Puskesmas",
                data: data.map(v => v.countPuskesmas)
              },
              {
                name: "Klinik",
                data: data.map(v => v.countKlinik)
              }
            ];

            console.log(_.series);

            data.forEach((v,k) => {
              //_.series[k].name = _.series[k].data[0];
              _.chartOptions.xaxis.categories.push(v.namaKota);
            });

            _.$nextTick(() => {
              _.$refs.chart.init();
            });
          })
      },
    },
    watch: {
      models: {
        handler(newVal, oldVal) {
          this.getData();
          this.chartOptions.title.text = 'Jenis Fasyankes per Kota/Kab, tahun ' + this.models.year;
        },
        deep: true,
      },
    },
  }
</script>